export const scrollToTop = (elementOrRef = 'main-content-wrapper') => {
    const el = (typeof elementOrRef === 'string')
        ? document.getElementById(elementOrRef)
        : (elementOrRef?.current || elementOrRef);

    console.log('scrolling to top', el);
    el?.scrollTo({
        top: 0,
        behavior: 'smooth',
    });
};
